import React, { Component } from 'react';
import { inject } from 'mobx-react';
import DocumentationGridRow from './DocumentationGridRow';
import { localeStrings as strings } from 'applicationConfig';
import DownloadHelper from '../../utils/DownloadHelper';

@inject('settingsStore')
class DocumentationGrid extends Component {
  downloadDocument = (href) => {
    const { downloadError, email } = strings.documentation;
    const { error } = strings.generic;
    const message = () => (<h3>{downloadError} <a href={'mailto:' + email} className="mailto">{email}</a></h3>);
    DownloadHelper
      .downloadFile(href)
      .catch(() => {
        this.props.settingsStore.setAlertData({
          title: error,
          ChildElement: message
        });
      });
  }

  render() {
    const { data } = this.props;
    return (
      <div className="documentation-grid">
        {data.map((item, index) => <DocumentationGridRow key={index} data={item} onClick={this.downloadDocument} />)}
      </div>
    );
  }
}

export default DocumentationGrid;



// WEBPACK FOOTER //
// ./src/containers/Documentation/DocumentationGrid.jsx